import { cn } from '@/lib/utils'

/**
 * Sidebar row styling, shared by both consoles.
 *
 * The platform sidebar (`admin-layout.tsx`) and the Community Console sidebar
 * (`@/components/community/console-layout`) are separate navigations on purpose
 * — mixing their entries is exactly what must never happen — but they are the
 * same product and have to look identical. Keeping the row style in one place
 * is what stops them drifting apart the moment one of them is touched.
 *
 * Compact rows on the white panel. Resting state is grey text and grey icons;
 * hover lifts both to near-black over the faintest fill, and active is one step
 * further with medium weight. Nothing here uses a heavy block, a shadow or a
 * colour — state is carried by ink and a single soft grey.
 */
/*
    Below `sm` both sidebars render inside a Sheet, where every row is TAPPED
    rather than clicked, so the rows take a 44px minimum there. It is `min-h`
    over the existing `h-9`, so the desktop rail keeps its compact rhythm.
*/
export const NAV_ROW = cn(
    'h-9 min-h-9 max-sm:min-h-11 gap-2.5 rounded-adm-nav px-2.5 text-[13px] font-normal text-adm-nav-muted',
    'transition-colors duration-150 ease-out motion-reduce:transition-none',
    '[&_svg]:size-4 [&_svg]:text-adm-nav-muted [&_svg]:transition-colors [&_svg]:duration-150',
    'hover:bg-adm-nav-hover hover:text-adm-nav-ink-strong hover:[&_svg]:text-adm-nav-ink-strong',
    'data-active:bg-adm-nav-active data-active:font-medium data-active:text-adm-nav-ink data-active:[&_svg]:text-adm-nav-ink',
    'focus-visible:ring-2 focus-visible:ring-adm-accent focus-visible:ring-offset-2'
)

export const NAV_SUB_ROW = cn(
    'h-8 min-h-8 max-sm:min-h-11 rounded-adm-nav px-2.5 text-[12.5px] text-adm-nav-muted',
    'transition-colors duration-150 ease-out motion-reduce:transition-none',
    'hover:bg-adm-nav-hover hover:text-adm-nav-ink-strong',
    'data-active:bg-adm-nav-active data-active:font-medium data-active:text-adm-nav-ink',
    'focus-visible:ring-2 focus-visible:ring-adm-accent focus-visible:ring-offset-2'
)
